import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addDataLayerEvent } from "../../../utils/data.layer.utils/data.layer.util";
import { pictDataForSelectDealerGTM } from "../../../utils/data.layer.utils/fad.data.layer.util";

const DealerContactCard = ({ selectedDealer, category, dealer, zoomToDealer, dealerListRef }) => {

	return (
		<div
			key={dealer.slug}
			ref={(ref) => {
				dealerListRef[dealer.slug] = ref;
			}}
			className={`dealer ${selectedDealer === dealer.slug
				? "active"
				: ""
				}`}
		>
			<div className="intro">
				<div
					className="location"
					onClick={() => {
						zoomToDealer(dealer);
					}}
				>
					<FontAwesomeIcon
						icon={[
							"far",
							"map-marker-alt",
						]}
					/>
				</div>
				<div className="titleHolder">
					<h5 className="title">
						{dealer.title}
					</h5>
					<div className="distance">
						{(
							dealer.address
								.distance * 1
						).toFixed(2)}
						km from you
					</div>
					<div className="address">
						{dealer.address.street1}{" "}
						{dealer.address.state
							? `, ${dealer.address.state}`
							: ""}{" "}
						{dealer.address.zip
							? `, ${dealer.address.zip}`
							: ""}
					</div>
				</div>
			</div>
			<div className="info">
				<div className="row">
					{dealer.contactUsNumber !== null && dealer.contactUsNumber !== "" &&
						<div className="col s6 valign-wrapper">
							<FontAwesomeIcon icon={["far", "phone-square"]} />
							<a
								href={`tel:+${dealer.contactUsNumber}`}
								title="Contact Us - Number"
							>
								{
									dealer.contactUsNumber
								}
							</a>
						</div>
					}
					{dealer.weekOfficeHours && dealer.weekOfficeHours !== null &&
						<div
							className="col s6 valign-wrapper"
						>
							<FontAwesomeIcon
								icon={[
									"far",
									"clock",
								]}
							/>
							{dealer.weekOfficeHours}
						</div>
					}
					{dealer.website && dealer.website.url !== null &&
						<div className="col s6 valign-wrapper">
							<FontAwesomeIcon icon={["far", "globe-africa",]} />
							<a
								href={dealer.website.url}
								target="_blank"
								title="Dealer Website"
							>
								{/* {dealer.website.text ?	dealer.website.text.replace("https://",	"")	.replace("http://",	"").replace("/","").replace("www.",	"") : "Dealer Site"} */}
								{dealer.website.text ? dealer.website.text : "Dealer Site"}
							</a>
						</div>
					}

					{dealer.weekendOfficeHours && dealer.weekendOfficeHours !== null &&
						<div
							className="col s6 valign-wrapper"
						>
							<FontAwesomeIcon
								icon={[
									"far",
									"clock",
								]}
							/>
							{
								dealer.weekendOfficeHours
							}
						</div>
					}
				</div>
			</div>
			<div className="buttons">
				<a
					title={`Get Directions For ${dealer.title}`}
					target="_blank"
					href={`https://www.google.com/maps/dir/Current+Location/${dealer.address.lat},${dealer.address.lng}`}
					className="waves-effect waves-light hButton buttonRed"
					onClick={(e) => {
						addDataLayerEvent("ButtonSelectDealerLocation", pictDataForSelectDealerGTM({ category: category, dealer: dealer }));
					}}
				>
					Get Directions
				</a>
			</div>
		</div>
	)
}


export default DealerContactCard;